// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"592":"38c52281","743":"b56cf8b2"}[chunkId] + ".chunk.js");